import React from 'react';
import { Link } from 'react-router-dom';

const BackLink = ({ to, title }) => {
    return (
        <div className="breadcrumbs">
            <div className="breadcrumbs__item">
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 13L1 7L7 1" stroke="#CC0514" />
                </svg>
                <Link className="breadcrumbs__link" to={to}>
                    {title}
                </Link>
            </div>
        </div>
    );
};

export default BackLink;
